module.exports = __webpack_public_path__ + "img/step5.950bf131.png";